'use client';

import { useEffect, useState } from 'react';
import { FullSizeLoader } from '@/src/components/Loader/FullSizeLoader';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';
import { useAuthValidation } from '@/src/lib/hooks/useAuthValidation';
import classes from './admin.module.scss';
import SiteOverviewPanel, { OverviewClient } from '@/src/components/AdminDashboardPanel/SiteOverviewPanel';
import { useParams } from 'next/navigation';

const Admin = () => {
  const dictionary = useDictionary();
  const { lang } = useParams();
  const { isLoading } = useAuthValidation();

  const [articles, setArticles] = useState({ count: 0, recent: [] });
  const [recentClients, setRecentClients] = useState<OverviewClient[] | undefined>(undefined);
  const [products, setProducts] = useState({ count: 0, recent: [] });
  const [quotes, setQuotes] = useState({ count: 0, recent: [] });
  const [invoices, setInvoices] = useState({ count: 0, recent: [] });
  const [tickets, setTickets] = useState({ count: 0, recent: [] });
  const [recentModels, setRecentModels] = useState(undefined);
  const [recentServices, setRecentServices] = useState(undefined);


  useEffect(() => {
    const fetchAll = async () => {
      const endpoints: [string, (data: any) => void][] = [
        ['/api/articles/summary', (data) => setArticles({
          count: data.total || 0,
          recent: (data.latest || []).map((item: any) => ({
            id: item._id,
            title: item.title,
            imageUrl: item.mainImage || '',
            description: item.description || '',
            link: item.link || '',
          })),
        })],
        ['/api/products/summary', (data) => setProducts({
          count: data.total || 0,
          recent: (data.latest || []).map((item: any) => ({
            id: item._id,
            title: item.title,
            imageUrl: item.mainImage || '',
            description: item.description || '',
            link: item.link || '',
          })),
        })],
        ['/api/accounting-manager/quotes/summary', (data) => setQuotes({
          count: data.total || 0,
          recent: (data.latest || []).map((item: any) => ({
            id: item._id,
            title: item.title,
            imageUrl: item.mainImage || '',
            description: item.description || '',
            link: item.link || '',
          })),
        })],
        ['/api/accounting-manager/invoices/summary', (data) => setInvoices({
          count: data.total || 0,
          recent: (data.latest || []).map((item: any) => ({
            id: item._id,
            title: item.title,
            imageUrl: item.mainImage || '',
            description: item.description || '',
            link: item.link || '',
          })),
        })],
        ['/api/accounting-manager/tickets/summary', (data) => setTickets({
          count: data.total || 0,
          recent: (data.latest || []).map((item: any) => ({
            id: item._id,
            title: item.title,
            imageUrl: item.mainImage || '',
            description: item.description || '',
            link: item.link || '',
          })),
        })],
        [`/api/${lang}/formdata/clients/summary`, (data) => setRecentClients(data.clients)],
        [`/api/${lang}/formdata/models/summary`, (data) => setRecentModels(data.models)],
        [`/api/${lang}/formdata/services/summary`, (data) => setRecentServices(data.services)],
      ];

      for (const [url, setter] of endpoints) {
        try {
          const res = await fetch(url);
          const data = await res.json();
          setter(data);
        } catch (err) {
          console.error(`Error fetching ${url}:`, err);
        }
      }
    };

    fetchAll();
  }, []);

  if (isLoading) return <FullSizeLoader />;

  return (
    <div className={classes.window}>
      <div className={classes.pageWrapper}>
        <SiteOverviewPanel
          articles={articles}
          products={products}
          quotes={quotes}
          invoices={invoices}
          tickets={tickets}
          clients={recentClients}
          models={recentModels}
          services={recentServices}
        />
      </div>
    </div>
  );
};

export default Admin;
